var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccesibilidadVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00361F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,56c53.4,0,103.7,20.8,141.4,58.5S456,202.6,456,256s-20.8,103.7-58.5,141.4S309.4,456,256,456 s-103.7-20.8-141.4-58.5S56,309.4,56,256s20.8-103.7,58.5-141.4S202.6,56,256,56 M256,34.4C133.7,34.4,34.4,133.7,34.4,256 S133.7,477.6,256,477.6S477.6,378.3,477.6,256S378.3,34.4,256,34.4L256,34.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,171.7c-29,0-52.6-23.6-52.6-52.6S227,66.4,256,66.4c29,0,52.6,23.6,52.6,52.6 C308.6,148.1,285,171.7,256,171.7z M256,85.7c-18.4,0-33.3,14.9-33.3,33.3s14.9,33.3,33.3,33.3s33.3-14.9,33.3-33.3 C289.3,100.7,274.4,85.7,256,85.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.8,440.2c-2.2,0-4.3-0.2-6.5-0.7l-3.6-0.8c-16-3.6-26.1-19.6-22.5-35.6l23.6-105.2 c0.1-4.9,0.6-33.2,0.8-55.5h-64.8c-8.5,0-16.6-3.4-22.5-9.5c-5.9-6.1-9.1-14.2-8.8-22.8c0.6-16.7,14.9-30.2,31.8-30.2h237.7 c8.5,0,16.6,3.4,22.5,9.5c5.9,6.1,9.1,14.2,8.8,22.8c-0.6,16.7-14.9,30.2-31.8,30.2h-64.2c0.2,22.7,0.5,50.6,0.6,55.5l23.6,105 c3.6,16-6.5,31.9-22.5,35.6l-3.6,0.8c-16,3.6-31.9-6.5-35.5-22.5l-17.1-75.3l-17.1,75.3C235.8,430.7,223.5,440.2,209.8,440.2z  M137.4,199.2c-6.7,0-12.3,5.2-12.5,11.6c-0.1,3.3,1.1,6.4,3.4,8.8c2.3,2.4,5.3,3.6,8.6,3.6h84.1v9.7c-0.7,66.5-0.9,67.2-1.1,68.5 l-23.9,105.9c-1.3,5.6,2.3,11.3,7.8,12.5l3.6,0.8c5.6,1.3,11.1-2.3,12.4-7.8L248,288.5h15.5l1.8,7.5l26.5,116.6 c1.3,5.6,6.8,9.1,12.4,7.8l3.6-0.8c5.6-1.3,9.2-6.8,7.8-12.5l-23.9-105.9c-0.3-1.4-0.5-1.8-0.9-68.4l-0.1-9.8h9.8h73.9 c6.7,0,12.3-5.2,12.5-11.6c0.1-3.3-1.1-6.4-3.4-8.8c-2.3-2.4-5.3-3.6-8.6-3.6H137.4V199.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccesibilidadVerde);
export default __webpack_public_path__ + "static/media/accesibilidad_verde.5c3f03f4ff64014aaca863bfd4f750fa.svg";
export { ForwardRef as ReactComponent };